<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-relational-database`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M44 40a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2a1 1 0 011-1h40zM43 6a2 2 0 012 2v27a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h38zm-2 4H7v23h34V10zm-9.001 12.696a1 1 0 011 1v1.191a1 1 0 01-1 1h-9.727v1.802a1 1 0 01-1.627.779l-3.76-3.026.005-.01-1.39-1.14a.9.9 0 01.572-1.596h15.927zm-5.272-8.384a1 1 0 01.627.221l3.462 2.788-.005.01.003.003 1.698 1.373a.898.898 0 01-.565 1.596H16a1 1 0 01-1-1V18.11a1 1 0 011-1h9.726v-1.8a1 1 0 011-1z"/></svg>
</template>
<script>

export default {
  name: 'IconRelationalDatabase',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
